import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_public/wheel-of-life")({
  staticData: { title: "Wheel of Life" },
  component: () => <Outlet />,
});
